import {useContext, useState} from 'react'

import PropTypes from 'prop-types'

import {ATOM_ICON_SIZES} from '@s-ui/react-atom-icon'
import AtomImage from '@s-ui/react-atom-image'
import Context from '@s-ui/react-context'
import MoleculeModal from '@s-ui/react-molecule-modal'
import {useLocation, useRouter} from '@s-ui/react-router'
import ModalBasicContent from '@adv-mt/mt-modal-basic-content'
import IconClose from '@adv-mt/mt-svg-icons/lib/Close.js'

import {ROUTES} from '../../../../config/index.js'

export const ModalReject = ({onModalClose, sellerName}) => {
  const {replace} = useRouter()
  const {domain, i18n} = useContext(Context)
  const {query} = useLocation()
  const [isLoading, setIsLoading] = useState(false)
  const [showNotificationError, setShowNotificationError] = useState(false)

  const {tradeId} = query

  const urlStaticsImages = domain.get('config').get('URL_STATICS_IMAGES')

  const imageUrl = `${urlStaticsImages}illustrations/come-back-soon.svg`

  const handleOnClickCtaBack = async () => {
    setIsLoading(true)
    setShowNotificationError(false)

    const [error] = await domain.get('reject_trade_buyer_transactions_use_case').execute({tradeId})

    setIsLoading(false)

    if (error) {
      setShowNotificationError(true)
      return
    }

    replace({pathname: ROUTES.USER.MESSAGES})
  }

  return (
    <MoleculeModal
      isOpen
      closeOnOutsideClick
      closeOnEscKeyDown
      iconClose={<IconClose size={ATOM_ICON_SIZES.medium} />}
      onClose={() => onModalClose(showNotificationError)}
      size="large"
    >
      <ModalBasicContent
        stepsContent={[
          {
            buttons: {
              cancelButton: {
                customCallBack: () => {
                  onModalClose(showNotificationError)
                },
                text: i18n.t('VEHICLE_TRANSACTION.CONFIRM_PRICE.MODAL_REJECT.CTA_CANCEL')
              },
              confirmButton: {
                customCallBack: () => {
                  handleOnClickCtaBack()
                },
                isLoading,
                text: i18n.t('COMMON.YES_SURE'),
                color: 'accent'
              }
            },
            children: (
              <div className="mt-UserTransactionPriceConfirm-modalRejectContent">
                <p>{i18n.t('VEHICLE_TRANSACTION.CONFIRM_PRICE.MODAL_REJECT.TEXT', {sellerName})}</p>
                {showNotificationError && (
                  <div className="mt-UserTransactionPriceConfirm-errorText">
                    {i18n.t('ERROR_MESSAGE_SERVER_CANCEL_TRADE')}
                  </div>
                )}
              </div>
            ),
            headerImage: (
              <div className="mt-UserTransactionPriceConfirm-modalRejectContentHeaderImageWrapper">
                <AtomImage
                  alt={i18n.t('VEHICLE_TRANSACTION.BUYER_CHECK_COSTS_LIST.MODAL_REJECT.TITLE')}
                  className="mt-UserTransactionPriceConfirm-modalRejectContentHeaderImage"
                  src={imageUrl}
                />
              </div>
            ),
            title: i18n.t('VEHICLE_TRANSACTION.CONFIRM_PRICE.MODAL_REJECT.TITLE')
          }
        ]}
      />
    </MoleculeModal>
  )
}

ModalReject.propTypes = {
  onModalClose: PropTypes.func,
  sellerName: PropTypes.string
}
